import type { RouterOutputs } from "~/utils/api";
import { isPositive } from "./is-positive";

export const constructDynamicsText = (dynamic: number | null) => {
  if (dynamic === null) {
    return "0 з останнього чекапу";
  }
  if (dynamic === 0) {
    return "0 з останнього чекапу";
  }
  if (isPositive(dynamic)) {
    return `+${dynamic} з останнього чекапу`;
  }
  return `${dynamic} з останнього чекапу`;
};

type Dynamic =
  RouterOutputs["slices"]["getAllLatestResults"][number]["dynamic"];

export const constructDynamicsTextSlices = (dynamic: number) => {
  if (dynamic === 0) {
    return "0";
  }
  if (isPositive(dynamic)) {
    return `+${dynamic}`;
  }
  return `${dynamic}`;
};

export const getSliceDynamicsStatus = (dynamic: Dynamic) => {
  if (dynamic.direction === "none") return "neutral";
  if (dynamic.direction === "up") return "success";
  if (dynamic.direction === "down") return "danger";
};
